export default {
  'formandbasic-form.basic.title': 'Basic form',
  'formandbasic-form.basic.description':
    'Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.',

  'formandbasic-form.email.required': 'Por favor insira seu email!',
  'formandbasic-form.email.wrong-format': 'O email está errado!',
  'formandbasic-form.userName.required': 'Por favor insira nome de usuário!',
  'formandbasic-form.password.required': 'Por favor insira sua senha!',
  'formandbasic-form.password.twice': 'As senhas não estão iguais!',
  'formandbasic-form.strength.msg':
    'Por favor insira pelo menos 6 caracteres e não use senhas fáceis de adivinhar.',
  'formandbasic-form.strength.strong': 'Força: forte',
  'formandbasic-form.strength.medium': 'Força: média',
  'formandbasic-form.strength.short': 'Força: curta',
  'formandbasic-form.confirm-password.required': 'Por favor confirme sua senha!',
  'formandbasic-form.phone-number.required': 'Por favor insira seu telefone!',
  'formandbasic-form.phone-number.wrong-format': 'Formato de telefone errado!',
  'formandbasic-form.verification-code.required': 'Por favor insira seu código de verificação!',

  'formandbasic-form.form.get-captcha': 'Get Captcha',
  'formandbasic-form.captcha.second': 'sec',
  'formandbasic-form.email.placeholder': 'Email',
  'formandbasic-form.password.placeholder': 'Senha',
  'formandbasic-form.confirm-password.placeholder': 'Confirme a senha',
  'formandbasic-form.phone-number.placeholder': 'Telefone',
  'formandbasic-form.verification-code.placeholder': 'Código de verificação',
  'formandbasic-form.form.optional': ' (optional) ',
  'formandbasic-form.form.submit': 'Submit',
  'formandbasic-form.form.save': 'Save',
  'formandbasic-form.title.label': 'Title',
  'formandbasic-form.title.placeholder': 'Give the target a name',
  'formandbasic-form.date.label': 'Start and end date',
  'formandbasic-form.placeholder.start': 'Start date',
  'formandbasic-form.placeholder.end': 'End date',
  'formandbasic-form.goal.label': 'Goal description',
  'formandbasic-form.goal.placeholder': 'Please enter your work goals',
  'formandbasic-form.standard.label': 'Metrics',
  'formandbasic-form.standard.placeholder': 'Please enter a metric',
  'formandbasic-form.client.label': 'Client',
  'formandbasic-form.label.tooltip': 'Target service object',
  'formandbasic-form.client.placeholder':
    'Please describe your customer service, internal customers directly @ Name / job number',
  'formandbasic-form.invites.label': 'Inviting critics',
  'formandbasic-form.invites.placeholder':
    'Please direct @ Name / job number, you can invite up to 5 people',
  'formandbasic-form.weight.label': 'Weight',
  'formandbasic-form.weight.placeholder': 'Please enter weight',
  'formandbasic-form.public.label': 'Target disclosure',
  'formandbasic-form.label.help': 'Customers and invitees are shared by default',
  'formandbasic-form.radio.public': 'Public',
  'formandbasic-form.radio.partially-public': 'Partially public',
  'formandbasic-form.radio.private': 'Private',
  'formandbasic-form.publicUsers.placeholder': 'Open to',
  'formandbasic-form.option.A': 'Colleague A',
  'formandbasic-form.option.B': 'Colleague B',
  'formandbasic-form.option.C': 'Colleague C',
};
